import FeatureLayer from '@arcgis/core/layers/FeatureLayer';

/**
 * Create and return an instance of the feature layer to be added to the map.
 * https://developers.arcgis.com/javascript/latest/add-a-feature-layer/
 * @param {String} url - GIS cached-basemap service url
 */
export const createFeatureLayer = async ({ url, ...props }) =>
  await handleFeatureLayer({ url, ...props });

async function handleFeatureLayer({ url, ...props }) {
  const featureLayer = new FeatureLayer({
    ...props,
    url,
  });

  // Layer must be loaded so that properties such as `geometryType` can be queried.
  // Possible values: 'point', 'multipoint', 'polyline', 'polygon', 'multipatch', or 'mesh'.
  // https://developers.arcgis.com/javascript/latest/api-reference/esri-layers-FeatureLayer.html#geometryType
  await featureLayer.load();

  return featureLayer;
}
